import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "content-features-desktop" }
const _hoisted_2 = { class: "content-title-features" }
const _hoisted_3 = {
  key: 0,
  class: "line-selected"
}
const _hoisted_4 = {
  key: 0,
  class: "line-selected"
}
const _hoisted_5 = { class: "features-slider" }
const _hoisted_6 = {
  key: 0,
  class: "floorpan-dimensions"
}
const _hoisted_7 = { class: "house-info-card-row-modified" }
const _hoisted_8 = { class: "row-value" }
const _hoisted_9 = { class: "house-info-card-row-modified" }
const _hoisted_10 = { class: "row-value" }
const _hoisted_11 = { class: "house-info-card-row-modified" }
const _hoisted_12 = { class: "row-value" }
const _hoisted_13 = {
  key: 1,
  class: "features"
}
const _hoisted_14 = { class: "features-list" }
const _hoisted_15 = { class: "feature-item" }
const _hoisted_16 = {
  key: 2,
  class: "inclusions"
}
const _hoisted_17 = { class: "house-info-card-row-slider" }
const _hoisted_18 = { class: "row-label" }
const _hoisted_19 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "content-feature-selected",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.setCurrentFeature($setup.BuilderFeatures.DIMENSIONS)))
      }, [
        _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "title-description" }, "Floor Plan Dimensions", -1)),
        ($props.currentFeature === $setup.BuilderFeatures.DIMENSIONS)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      ($props.house.features)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "content-feature-selected",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.setCurrentFeature($setup.BuilderFeatures.FEATURES)))
          }, [
            _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "title-description" }, "Features", -1)),
            ($props.currentFeature === $setup.BuilderFeatures.FEATURES)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      ($props.house.inclusions)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "content-feature-selected hidden",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.setCurrentFeature($setup.BuilderFeatures.INCLUSIONS)))
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      ($props.currentFeature === $setup.BuilderFeatures.DIMENSIONS)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "row-label" }, "Area:", -1)),
              _createElementVNode("div", _hoisted_8, _toDisplayString($setup.formatMeters($props.house.area, false)) + " SQM", 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "row-label" }, "Width:", -1)),
              _createElementVNode("div", _hoisted_10, _toDisplayString($setup.formatMeters($props.house.width, false)) + " M", 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "row-label" }, "Length:", -1)),
              _createElementVNode("div", _hoisted_12, _toDisplayString($setup.formatMeters($props.house.length, false)) + " M", 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ($props.house.features && $props.currentFeature === $setup.BuilderFeatures.FEATURES)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("ul", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.house.features, (feature) => {
                return (_openBlock(), _createElementBlock("li", _hoisted_15, _toDisplayString(feature), 1))
              }), 256))
            ])
          ]))
        : _createCommentVNode("", true),
      ($props.house.inclusions && $props.currentFeature === $setup.BuilderFeatures.INCLUSIONS)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.house.inclusions, ({ name, url }) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, _toDisplayString(name), 1),
                _createElementVNode("a", {
                  class: "row-value",
                  href: url,
                  target: "_blank"
                }, "Download", 8, _hoisted_19)
              ]))
            }), 256))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}